import request from "./request";

/**
 * 获取微信 JS-SDK 配置
 * 后端需根据当前 URL 生成签名并返回 appId、timestamp、nonceStr、signature
 */
export function getWechatConfig(params = {}) {
  return request({
    url: "/wechat/config",
    method: "get",
    params,
  });
}

/**
 * 获取微信 JS-API 配置
 */
export function getJsapiConfig(params = {}) {
  return request({
    url: "/mp/user/getJsapiConfig",
    method: "get",
    params,
  });
}

export * from "./order";
export * from "./login";
export * from "./user";
export * from "./file";
